import React from "react";
import Message from "./Message";
function ChatMessages(props) {
    return (
        <section className="section-chat">
            {props.messages.map((message, index, list) => {
                return (
                    <Message
                        {...props}
                        prevMessage={list[index - 1]}
                        message={message}
                        key={message.id}
                        id={message.id}
                    />
                );
            })}
        </section>
    );
}
export default ChatMessages;
